const content_switcher_visible = document.querySelector('.content-switcher')

if (content_switcher_visible) {
	document.addEventListener('click', (e) => {
		// Look for a click on any element with the data-targets attribute
		if (e.target.dataset.targets) {
			const elements_to_activate = document.querySelectorAll(e.target.dataset.targets);
			const elements_to_hide = [];
			const nav_class = '.content-switcher__nav-link';
			const content_class = '.content-switcher__content-item';
	
			// Look for every nav item, loop through and push the returned element to an array.
			document.querySelectorAll(nav_class).forEach(el => {
				elements_to_hide.push(el);
			});
			// Look for every content item, loop through and push the returned element to an array.
			document.querySelectorAll(content_class).forEach(el => {
				elements_to_hide.push(el);
			});
	
			// Every time an element with the data-targets attribute is clicked, remove all active classes on previously created array
			elements_to_hide.forEach(el => {
				el.classList.remove('active');
			});
	
			// Every time an element with the data-targets attribute is clicked, add the active class to the respective element
			elements_to_activate.forEach(el => {
				el.classList.add('active');
			});
		}
	})
}